// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"ef08086e","186":"e64ef256","450":"97ec21c8","628":"4249c355","963":"e90d6f76"}[chunkId] + ".chunk.js";
};